/* global BigInt */
import EventEmitter from 'eventemitter3';

import Web3 from 'web3'

import BlockStreamer from './blockStreamer';
import {
  conversion,
  add,
  BANNED,
  ZERO_ADDRESS,
  readJSON,
  writeJSON,
  MAX_REORG_DEPTH,
  TRANSFER_TOPIC,
  SYNC_TOPIC,
  LIQUIDITY,
  FIRST_SEEN,
  INFO,
  CLAIMABLE,
  MERKLE_TREE,
} from './utils';

const REWARDER_ABI = [{ "inputs": [{ "internalType": "address", "name": "_token", "type": "address" }, { "internalType": "address payable", "name": "_custody", "type": "address" }, { "internalType": "address", "name": "_uniswapPair", "type": "address" }, { "internalType": "uint256", "name": "_tokenStart", "type": "uint256" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "totalDropped", "type": "uint256" }], "name": "Airdrop", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "address", "name": "account", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "banned", "type": "bool" }], "name": "BanChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "pricePerBlock", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "blocksPeriod", "type": "uint256" }], "name": "PriceUpdated", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "tokenStart", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "uniswapPair", "type": "address" }], "name": "RewarderDeployed", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "root", "type": "bytes32" }, { "indexed": false, "internalType": "uint256", "name": "blockNumber", "type": "uint256" }], "name": "RootUpdated", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "totalUnclaimed", "type": "uint256" }], "name": "UnclaimedChanged", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "banlist", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "claimRoots", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "custody", "outputs": [{ "internalType": "contract Custody", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "deployBlock", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lastBlockNumber", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lastBlocksPeriod", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lastRootBlock", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "pricePerBlock", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "token", "outputs": [{ "internalType": "contract IERC20", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "totalPayoutsFor", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalUnclaimed", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address[]", "name": "beneficiaries", "type": "address[]" }, { "internalType": "uint256[]", "name": "totalEarnings", "type": "uint256[]" }], "name": "airdrop", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "newPricePerBlock", "type": "uint256" }, { "internalType": "uint256", "name": "blocksPeriod", "type": "uint256" }], "name": "updatePrice", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes32", "name": "claimRoot", "type": "bytes32" }, { "internalType": "uint256", "name": "blockNumber", "type": "uint256" }], "name": "updateRoot", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "totalEarned", "type": "uint256" }, { "internalType": "uint256", "name": "blockNumber", "type": "uint256" }, { "internalType": "bytes32[]", "name": "proof", "type": "bytes32[]" }], "name": "claim", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "totalEarned", "type": "uint256" }, { "internalType": "uint256", "name": "blockNumber", "type": "uint256" }, { "internalType": "bytes32[]", "name": "proof", "type": "bytes32[]" }], "name": "isValidProof", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "erc20", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "recoverTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "ban", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "unban", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]
const ERC20_ABI = [{ "inputs": [{ "internalType": "string", "name": "name_", "type": "string" }, { "internalType": "string", "name": "symbol_", "type": "string" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }]
const UNISWAP_PAIR_ABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1", "type": "uint256" }], "name": "Mint", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0In", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1In", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount0Out", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1Out", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }], "name": "Swap", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint112", "name": "reserve0", "type": "uint112" }, { "indexed": false, "internalType": "uint112", "name": "reserve1", "type": "uint112" }], "name": "Sync", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "DOMAIN_SEPARATOR", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "MINIMUM_LIQUIDITY", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "PERMIT_TYPEHASH", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "burn", "outputs": [{ "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "internalType": "uint256", "name": "amount1", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "factory", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "getReserves", "outputs": [{ "internalType": "uint112", "name": "_reserve0", "type": "uint112" }, { "internalType": "uint112", "name": "_reserve1", "type": "uint112" }, { "internalType": "uint32", "name": "_blockTimestampLast", "type": "uint32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_token0", "type": "address" }, { "internalType": "address", "name": "_token1", "type": "address" }], "name": "initialize", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "kLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "mint", "outputs": [{ "internalType": "uint256", "name": "liquidity", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "nonces", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }, { "internalType": "uint8", "name": "v", "type": "uint8" }, { "internalType": "bytes32", "name": "r", "type": "bytes32" }, { "internalType": "bytes32", "name": "s", "type": "bytes32" }], "name": "permit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "price0CumulativeLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "price1CumulativeLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "skim", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount0Out", "type": "uint256" }, { "internalType": "uint256", "name": "amount1Out", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "swap", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "sync", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "token0", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "token1", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }]
const WARP_BLOCK_DELTA = 1000
/**
 * Performs reward calculations. Follows current blockchain state and handles reorgs.
 *
 * Events:
 * - `update` - participants table has changed
 */
export default class Rewarder extends EventEmitter {
  constructor(snapshot, rootsFn, web3) {
    super()
    this.snapshot = snapshot
    this.snapshot.claimable = {}
    const { token, rewarder, uniswap, decimals, symbol, lastRootBlock } = this.snapshot[INFO]
    this.tokenAddress = Web3.utils.toChecksumAddress(token)
    this.rewarderAddress = Web3.utils.toChecksumAddress(rewarder)
    this.uniswapAddress = Web3.utils.toChecksumAddress(uniswap)
    this.decimals = decimals
    this.tokenSymbol = symbol
    this.lastRootBlock = lastRootBlock
    this.initialSnapshot = writeJSON(snapshot)
    this.blockReward = this.snapshot.price.value
    this.currentBlock = this.snapshot.block

    const { toTokens, fromTokens } = conversion(8, this.decimals)
    this.toTokens = toTokens
    this.fromTokens = fromTokens

    this.rootsFn = rootsFn
    this.web3 = web3
  }

  async initialize() {
    if (this.merkleTree) return

    await this.updateMerkleTree(this.lastRootBlock)

    if (!this.web3) return

    this.rewarderTopics = {
      ...this.getRewarderEvent('PriceUpdated'),
      ...this.getRewarderEvent('BanChanged'),
      ...this.getRewarderEvent('RootUpdated'),
    }
    this.setupStreaming()
  }

  async updateMerkleTree(blockNumber) {
    try {
      this.merkleTree = await this.rootsFn(`root_${blockNumber}.json`)
      this.updateClaimable()
    } catch {
      // Merkle Tree is not updated, leave everything as is
    }
  }

  updateClaimable() {
    this.snapshot.claimable = this.merkleTree.leaves.reduce(
      (acc, cur) => Object.assign(acc, { [cur.address]: cur.earned }),
      {}
    )
  }

  getPeriodStartTime() {
    return new Date(this.snapshot.price.fromTime * 1000)
  }

  getPeriodStart() {
    return Number(this.snapshot.price.from)
  }

  getPeriodLength() {
    return Number(this.snapshot.price.period)
  }

  getPeriodEnd() {
    return Number(this.snapshot.price.from) + Number(this.snapshot.price.period)
  }

  getPeriodNumber() {
    return this.snapshot.periods
  }

  getPeriodBlocksLeft() {
    return Math.max(this.getPeriodEnd() - this.currentBlock, 0)
  }

  getParticipants() {
    const totalSupply = -this.snapshot[this.uniswapAddress][ZERO_ADDRESS]
    const { reserve0, reserve1 } = this.snapshot[LIQUIDITY]
    return Object.entries(this.snapshot[this.uniswapAddress])
      .filter(
        ([participant]) =>
          participant !== ZERO_ADDRESS && !this.snapshot[BANNED][participant] && participant !== this.rewarderAddress
      )
      .map(([participant, shares]) => {
        const totalEarned = this.snapshot[this.rewarderAddress][participant] || 0n
        const totalPaid = this.snapshot[this.tokenAddress][participant] || 0n
        const earned = totalEarned - totalPaid
        return {
          participant,
          totalEarned,
          earned,
          paid: totalPaid,
          claimable: this.snapshot[CLAIMABLE]
            ? this.snapshot[CLAIMABLE][participant] || 0n
            : BigInt(this.snapshot.claimable[participant] || 0) - totalPaid,
          liquidity0: (shares * BigInt(reserve0)) / totalSupply,
          liquidity1: (shares * BigInt(reserve1)) / totalSupply,
          firstSeenBlock: this.snapshot[FIRST_SEEN][participant].block,
          firstSeenTime: new Date(this.snapshot[FIRST_SEEN][participant].timestamp * 1000),
        }
      })
  }

  canClaim(participant) {
    if (!this.web3) return false

    const account = Web3.utils.toChecksumAddress(participant)

    return this.snapshot[MERKLE_TREE] && !!this.snapshot[MERKLE_TREE].proofs[account]
  }

  async claim(participant, from) {
    if (!this.web3) throw new Error(`Web3 is not initialized!`)

    const account = this.web3.utils.toChecksumAddress(participant)
    const proof = this.snapshot[MERKLE_TREE].proofs[account]
    if (!proof) throw new Error(`Unable to find proof for: ${participant}`)

    const rewarder = new this.web3.eth.Contract(REWARDER_ABI, this.rewarderAddress)
    return rewarder.methods.claim(account, proof.earned, this.snapshot[MERKLE_TREE].block, proof.proof).send({
      from,
    })
  }

  getRewarderEvent(event) {
    return {
      [this.encodeEvent(REWARDER_ABI, event)]: {
        name: event,
        decoder: (log) => this.decodeEvent(REWARDER_ABI, event, log),
      },
    }
  }

  encodeEvent(abi, event) {
    const events = abi.filter((x) => x.type === 'event' && x.name === event)
    if (events.length === 0) throw new Error(`Unknown event: ${event}`)
    return this.web3.eth.abi.encodeEventSignature(events[0])
  }

  decodeEvent(abi, event, log) {
    const events = abi.filter((x) => x.type === 'event' && x.name === event)
    if (events.length === 0) throw new Error(`Unknown event: ${event}`)
    return this.web3.eth.abi.decodeLog(events[0].inputs, log.data, log.topics.slice(1))
  }

  setupStreaming() {
    this.startStreaming().catch((error) => {
      console.error(error)
      this.snapshot = readJSON(this.initialSnapshot)
      this.updateMerkleTree(this.snapshot[INFO].lastRootBlock).then(() => {
        this.setupStreaming()
      })
    })
  }

  async startStreaming() {
    this.blockReward = this.snapshot.price.value
    this.currentBlock = (await this.web3.eth.getBlockNumber()) - MAX_REORG_DEPTH
    if (this.currentBlock > this.snapshot.block) {
      await this.warpTo(this.currentBlock)
      this.snapshot.block = this.currentBlock
    }

    const blockStreamer = new BlockStreamer(this.web3)
    while (true) {
      console.log(`Streaming from block: ${this.snapshot.block}`)
      const parentHashes = []
      const parentHashesIdx = {}

      for await (const { number: block, hash, parentHash } of blockStreamer.blocks(this.snapshot.block)) {
        if (parentHashes.length > 0 && parentHashes[0] !== parentHash) {
          this.snapshot = await blockStreamer.rewind(parentHash, parentHashesIdx)
          await this.updateMerkleTree(this.snapshot[INFO].lastRootBlock)
          console.log(`Reorg detected at block: ${block} (${hash}). Rolling back to block: ${this.snapshot.block}`)
          break
        }
        this.currentBlock = block
        this.snapshot.block = block
        parentHashes.unshift(hash)
        parentHashesIdx[hash] = readJSON(writeJSON(this.snapshot))
        if (parentHashes.length > MAX_REORG_DEPTH) {
          delete parentHashesIdx[parentHashes.pop()]
        }
        this.checkPeriodEnd(block)
        this.payForBlock()
        const logs = await this.getLogs(block)
        await this.processLogs(logs)
        this.emit('update')
      }
    }
  }

  async getLogs(fromBlock, toBlock = fromBlock) {
    return this.web3.eth.getPastLogs({
      fromBlock,
      toBlock,
      address: [this.uniswapAddress, this.tokenAddress, this.rewarderAddress],
    })
  }

  async warpTo(currentBlock) {
    const from = this.snapshot.block
    console.log(`Warp: ${from} - ${currentBlock}`)
    // esline-disable-next-line no-restricted-syntax
    for (let fromBlock = from; fromBlock <= currentBlock; fromBlock += WARP_BLOCK_DELTA) {
      const toBlock = Math.min(fromBlock + WARP_BLOCK_DELTA - 1, currentBlock)
      const logs = await this.getLogs(fromBlock, toBlock)
      // ensure logs are sorted
      logs.sort((a, b) => {
        if (a.blockNumber === b.blockNumber) return a.logIndex - b.logIndex
        return a.blockNumber - b.blockNumber
      })

      for (let block = fromBlock; block <= toBlock; block += 1) {
        this.snapshot.block = block
        this.checkPeriodEnd(block)
        this.payForBlock()
        const filteredLogs = logs.filter((x) => x.blockNumber === block)
        if (filteredLogs.length > 0) {
          await this.processLogs(filteredLogs)
        }
      }
      this.emit('update')
    }
    console.log(`Warp: Completed`)
  }

  payForBlock() {
    let sharesDistributed = 0n
    let rewardsDistributed = 0n

    const distribution = this.blockReward
    const totalSupply =
      -this.snapshot[this.uniswapAddress][ZERO_ADDRESS] -
      Object.entries(this.snapshot[BANNED])
        .filter(([, banned]) => banned)
        .map(([participant]) => this.snapshot[this.uniswapAddress][participant])
        .filter((x) => !!x) // filter undefined and null
        .reduce((a, b) => a + b, 0n)

    for (const [participant, shares] of Object.entries(this.snapshot[this.uniswapAddress])) {
      // eslint-disable-next-line no-continue
      if (participant === ZERO_ADDRESS) continue
      // eslint-disable-next-line no-continue
      if (shares === 0n) continue
      // eslint-disable-next-line no-continue
      if (this.snapshot[BANNED][participant]) continue

      sharesDistributed += shares
      const rewardsDistributedX = (sharesDistributed * distribution) / totalSupply
      let reward = (shares * distribution) / totalSupply

      rewardsDistributed += reward

      const rewardsRoundingError = rewardsDistributedX - rewardsDistributed
      reward += rewardsRoundingError
      rewardsDistributed += rewardsRoundingError
      add(this.snapshot[this.rewarderAddress], participant, reward)
    }
  }

  async processLogs(logs) {
    for (const log of logs) {
      // eslint-disable-next-line no-await-in-loop
      await this.processLog(log)
    }
  }

  async processLog(log) {
    const { address } = log
    switch (address) {
      case this.uniswapAddress: {
        const { topics } = log
        if (topics.length === 0) return

        await this.processUniswapEvent(log)
        break
      }
      case this.tokenAddress: {
        const { topics } = log
        if (topics.length === 0 || topics[0] !== TRANSFER_TOPIC) return
        await this.processTransferEvent(log)
        break
      }
      case this.rewarderAddress: {
        if (!this.rewarderTopics[log.topics[0]]) break

        const event = this.rewarderTopics[log.topics[0]]
        await this.processRewarderEvent(event, log)
        break
      }
      default:
        console.error(`Event from unknown source: ${log}`)
        break
    }
  }

  async processUniswapEvent(log) {
    const { topics } = log
    const topic = topics[0]
    switch (topic) {
      case TRANSFER_TOPIC:
        await this.processTransferEvent(log)
        break
      case SYNC_TOPIC: {
        const { reserve0, reserve1 } = this.decodeEvent(UNISWAP_PAIR_ABI, 'Sync', log)
        this.snapshot[LIQUIDITY] = {
          reserve0: BigInt(reserve0),
          reserve1: BigInt(reserve1),
        }
        break
      }
      default:
        break
    }
  }

  async processTransferEvent(log) {
    const { address, blockNumber } = log
    const { from, to, value } = this.decodeEvent(ERC20_ABI, 'Transfer', log)
    if (address === this.tokenAddress && from !== this.rewarderAddress) return

    add(this.snapshot[address], from, -BigInt(value))
    add(this.snapshot[address], to, BigInt(value))

    if (address === this.uniswapAddress && !this.snapshot[FIRST_SEEN][to]) {
      const block = await this.web3.eth.getBlock(blockNumber)
      this.snapshot[FIRST_SEEN][to] = {
        block: Number(blockNumber),
        timestamp: block.timestamp,
      }
    }
  }

  async processRewarderEvent(event, log) {
    const decoded = event.decoder(log)
    switch (event.name) {
      case 'PriceUpdated': {
        const { blockNumber } = log
        const { pricePerBlock, blocksPeriod } = decoded
        this.blockReward = BigInt(pricePerBlock)
        this.snapshot.price.value = BigInt(pricePerBlock)
        this.snapshot.price.from = blockNumber
        this.snapshot.price.fromTime = (await this.web3.eth.getBlock(blockNumber)).timestamp
        this.snapshot.price.period = Number(blocksPeriod)
        this.snapshot.periods += 1
        this.checkPeriodEnd(blockNumber)
        break
      }
      case 'RootUpdated': {
        const { blockNumber } = decoded
        await this.updateMerkleTree(blockNumber)
        break
      }
      case 'BanChanged': {
        const { account, banned } = decoded
        this.snapshot[BANNED][account] = banned
        break
      }
      default:
        console.error(`Unknown Rewarder event: ${event.name}`)
        break
    }
  }

  checkPeriodEnd(blockNumber) {
    if (Number(blockNumber) !== this.getPeriodEnd()) return

    this.blockReward = 0n
    this.snapshot.price.value = 0n
    this.snapshot.price.from = Number(blockNumber)
    this.snapshot.price.period = 0
  }
}
